import { Action, createReducer, on } from '@ngrx/store';
import * as HomeStoreActions from './home-store.actions';
import { StatisticsItem } from '../models/statistics-item';
import { NewsItem } from '../models/news-item';

export const homeStoreFeatureKey = 'homeStore';

export interface State {
    statisticsData?: StatisticsItem[];
    news?: NewsItem[];
    loadedAllNews?: boolean;
    selectedNewsId?: number;
}

export const initialState: State = {
    statisticsData: [],
    news: [],
    loadedAllNews: false,
};

export const reducer = createReducer(
    initialState,

    on(HomeStoreActions.loadHomeStores, (state) => state),
    on(HomeStoreActions.loadStatisticsData, (state, action) => {
        // set measurecount and samplecount to null. action.statisticsData.item is readonly
        const data = [...action.statisticsData];
        data.forEach((item, index) => {
            data[index] = { ...item, measurecount: null, samplecount: null };
        });

        return { ...state, statisticsData: [...data] };
    }),
    on(HomeStoreActions.loadNewsSuccess, (state, action) => {
        return {
            ...state,
            news: action.news,
            loadedAllNews: action.news.length > 4,
        };
    }),
    on(HomeStoreActions.setSelectedNewsId, (state, action) => {
        return { ...state, selectedNewsId: action.id };
    }),
    on(HomeStoreActions.updateHomePageStatistics, (state, action) => {
        const statisticsData = [...state.statisticsData];
        action.statisticsData.forEach((item) => {
            const index = statisticsData.findIndex((x) => x.id === item.sampleTypeId);
            if (index > -1) {
                statisticsData[index] = { ...statisticsData[index], measurecount: item.numberOfMeasurements, samplecount: item.numberOfSamples };
            }
        });
        return { ...state, statisticsData };
    })
);
